import './style.css';
import { bootstrapGated } from '@/app/AppBootstrap';
import { SplashScreen } from '@/ui/SplashScreen';

const container = document.getElementById('app');
if (!container) {
  throw new Error('Root container #app not found');
}

// Mounted before the probe below is awaited, so the held second is counted from when the page
// opened rather than from whenever the server gets round to answering. The splash is its own layer
// on <body>, which is what lets it play over the editor and over the sign-in wall without either
// of them knowing it is there — and nothing waits on it: it dissolves on its own clock.
const splash = SplashScreen.show();

// Awaited because a gated deployment must not construct the editor for someone who may not use it.
// On every other configuration the probe resolves immediately or fails closed to local mode, so
// this costs one request and changes nothing the user sees.
// The splash's own promise is handed over as the opening curtain: the first-run tutorial waits for
// it rather than playing out behind a film nobody can see through. Nothing else waits on it.
const booted = await bootstrapGated({ container, openingCurtain: splash.finished });
const app = booted.kind === 'app' ? booted.app : null;

// Development-only handle for the smoke scripts, which need to read canonical state (terrain
// heights, the project document) that the HUD deliberately does not put in the DOM. Stripped from
// production builds by the constant fold on `import.meta.env.DEV`.
if (import.meta.env.DEV && app) {
  (globalThis as unknown as { __lgApp?: unknown }).__lgApp = app;
}

// Dispose cleanly on hot-module replacement during development.
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    // Taken down first: a hot reload part-way through the opening would otherwise leave a detached
    // layer holding a 1080p decoder open on top of the replaced editor.
    splash.dispose();
    booted.dispose();
  });
}
